export const OTHER = 'OTHER'

// SDK methods called in wrong order
export const NOT_INITIALIZED = 'NOT_INITIALIZED'
export const NO_USER_AUTHENTICATED = 'NO_USER_AUTHENTICATED'

// depending on status code
export const CONNECTION_FAILED = 'CONNECTION_FAILED'
export const SERVER_ERROR = 'SERVER_ERROR'
export const UNAUTHORIZED = 'UNAUTHORIZED'
export const FORBIDDEN = 'FORBIDDEN'

// relative to BatchUploader
export const BATCH_IS_BEING_SENT = 'BATCH_IS_BEING_SENT'
export const BATCH_IS_ALREADY_SENT = 'BATCH_IS_ALREADY_SENT'

/**
 * Synchronized with backend
 **/

export const INVALID_PARAMETER = 'invalid_parameter' // => options must have (parameter / reason)

// relative to user sign up
export const LEGACY_PARTNER = 'legacy_partner'

// relative to receipt create v2
export const RECEIPT_NOT_REPLACEABLE = 'receipt_not_replaceable'

// relative to transfer payments
export const MISSING_PAYMENT_INFORMATION = 'missing_payment_information'
export const EMPTY_POT = 'empty_pot'
// export const NEGATIVE_BALANCE_ON_CARD = 'negative_balance_on_card'
// export const TRANSFERTS_BLOCKED = 'transfers_blocked'
// export const RECEIPT_WAITING_FOR_REVIEW = 'receipt_waiting_for_review'



// WEBPACK FOOTER //
// ./src/ErrorCodes.js